import type { RankingFullRankingBlock } from '../../types';
import { FullRankingDisclosure } from './FullRankingDisclosure';

interface FullRankingBlockProps extends RankingFullRankingBlock {
  locale: string;
}

export const FullRankingBlock = (props: FullRankingBlockProps) => {
  const { title, intro, tableCaption, entries, filters, summaryLabel, locale } = props;

  return (
    <div>
      <h3 id="full-ranking" className="scroll-mt-24 pt-4 text-xl font-semibold text-secondary-950">
        {title}
      </h3>
      <p className="mt-2 leading-relaxed text-secondary-700">{intro}</p>
      <div className="mt-4">
        <FullRankingDisclosure
          caption={tableCaption}
          entries={entries}
          filters={filters}
          summaryLabel={summaryLabel}
          locale={locale}
        />
      </div>
    </div>
  );
};
